const DEVICE_ID_KEY = "uprasti_device_id";

function createFallbackId() {
  return `dev_${Date.now()}_${Math.random().toString(36).slice(2)}_${Math.random()
    .toString(36)
    .slice(2)}`;
}

export function getOrCreateDeviceId() {
  try {
    let deviceId =
      localStorage.getItem(DEVICE_ID_KEY) ||
      localStorage.getItem("deviceId");

    if (!deviceId) {
      if (window.crypto && typeof window.crypto.randomUUID === "function") {
        deviceId = window.crypto.randomUUID();
      } else {
        deviceId = createFallbackId();
      }
    }

    localStorage.setItem(DEVICE_ID_KEY, deviceId);

    // Старый ключ тоже оставляем, потому что он уже используется для push/unsubscribe.
    localStorage.setItem("deviceId", deviceId);

    document.cookie = `deviceId=${encodeURIComponent(
      deviceId
    )}; path=/; max-age=31536000; SameSite=Lax`;

    return deviceId;
  } catch (error) {
    console.error("getOrCreateDeviceId error:", error);
    return "";
  }
}

export function setupAxiosDeviceId(axiosInstance) {
  const deviceId = getOrCreateDeviceId();

  if (deviceId && axiosInstance?.defaults?.headers?.common) {
    axiosInstance.defaults.headers.common["X-Device-Id"] = deviceId;
  }

  return deviceId;
}
